/**
 * Whether a keystroke belongs to something the user is typing into.
 *
 * Global shortcuts have to yield to text entry, and testing the tag name alone
 * misses the case that matters most here: the script is edited in
 * `contentEditable` spans, which are `SPAN` elements. Space toggled playback
 * instead of inserting a space, the arrow keys scrubbed instead of moving the
 * caret, and undo rolled back the timeline instead of the sentence.
 *
 * `isContentEditable` is inherited, so this is also true for anything nested
 * inside an editable region.
 */
export function isTypingInto(target: EventTarget | null): boolean {
  const element = target as HTMLElement | null;
  if (!element) return false;
  if (element.isContentEditable) return true;
  return /^(INPUT|TEXTAREA|SELECT)$/.test(element.tagName);
}
